import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConfigService } from '../../../core/auth/services/config.service';
import { Observable } from 'rxjs';
import { BMIHistoryResponse } from '../bmi-const/bmi-details-models';
import { TimePeriodFilter } from '../../assesment-detail/assesment-const/assessment-details-models';

@Injectable({
  providedIn: 'root'
})
export class BmiDetailsService {

    private httpClient = inject(HttpClient);
    private configService = inject(ConfigService);
    private baseUrl = this.configService.getPatientAPIUrl();
    private apiUrl = this.configService.getAPIUrl(); // v2

  constructor() { }

  getBMIHistory(patientId: string, filter?: TimePeriodFilter): Observable<BMIHistoryResponse> {
    let url = `${this.apiUrl}/api/Patient/bmiHistory?Patient_id=${patientId}`;
    if (filter) {
      url += `&Filter=${filter}`;
    }
    return this.httpClient.get<BMIHistoryResponse>(url);
  }
}
